<img
  src="/assets/logo/large-logo.svg"
  alt="background-img"
  class="background-img"
/>
<div class="Chess-Puzzles-page-background-color">

  <div class="container-fluid">
    <div
      class="row mx-2 my-2 px-1 justify-content-start move-scroll horizontal-moves"
      #moveScrollContainer
    >
      <div
        *ngFor="let item of moves; let i = index"
        class="col-6 move-one-section p-0 mb-0 mt-1"
      >
        <div class="d-flex align-items-center">
          <span *ngIf="i % 2 === 0" class="font mb-1 ms-2 numbers"
            >{{ i / 2 + 1 }}.</span
          >
          <p
            class="mb-1 move-box-border"
            (click)="getMove(i)"
            [innerHTML]="item | pieceIcon"
            [ngClass]="{ 'selected-move': i + 1 === currentIndex }"
          >
            {{ item }}
          </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8 play-with-friend-Game">
        <div class="mb-2 text-center">
          <h5 class="player-name-text">
            {{
              isFlipped ? chessboardDetails?.White : chessboardDetails?.Black
            }}
            @if (chessboardDetails?.BlackElo && chessboardDetails?.WhiteElo) {
            <span class="elo-text">
              ({{
                isFlipped
                  ? chessboardDetails?.WhiteElo
                  : chessboardDetails?.BlackElo
              }})</span
            >}
          </h5>
        </div>
        <div class="d-flex justify-content-center">
          <div class="Main-chessBoard">
            <div #boardContainer id="hijk"></div>
            <canvas id="arrowCanvas"></canvas>
          </div>
        </div>
        <div class="mt-2 text-center">
          <h5 class="player-name-text">
            {{
              isFlipped ? chessboardDetails?.Black : chessboardDetails?.White
            }}
            @if (chessboardDetails?.BlackElo && chessboardDetails?.WhiteElo) {
            <span class="elo-text">
              ({{
                isFlipped
                  ? chessboardDetails?.BlackElo
                  : chessboardDetails?.WhiteElo
              }})</span
            >}
          </h5>
        </div>
      </div>
      <div class="col-md-4 puzzle-menu-section px-0">
        <div class="m-2" style="color: var(--default-font-color);cursor: pointer;width: fit-content;"  (click)="mainMenu()">
          <i class="fa-solid me-1 fa-arrow-left" style="color: var(--default-font-color);font-size: 15px;"></i>Back
        </div>
        <div class="mb-5 mt-3 mobile-order-type">
          <div class="px-2 move-section">
            <div class="mb-2">
              <p class="font">
                Event -
                <span class="text">{{ chessboardDetails?.Event }}</span>
                <span class="chessboard-Date" style="padding-left: 4px"
                  >({{ chessboardDetails?.Date }})</span
                >
              </p>
            </div>

            @if(whiteWinner){
            <div>
              <p class="font">
                Winner -
                <span class="text">{{ chessboardDetails?.White }}</span>
              </p>
            </div>
            }@else if (blackwinner) {
            <div>
              <p class="font">
                Winner -
                <span class="text">{{ chessboardDetails?.Black }}</span>
              </p>
            </div>
            }@else if(drawgame){
            <div>
              <p class="font">Result - <span class="text">Draw</span></p>
            </div>
            }
            <div>
              <p class="font">
                Site -
                <span class="text">{{ chessboardDetails?.Site }}</span>
              </p>
            </div>

            @if (chessboardDetails?.Opening || chessboardDetails?.ECO) {
            <div>
              <p class="font">
                {{
                  chessboardDetails?.Opening
                    ? "Opening - " + chessboardDetails?.Opening
                    : "ECO - " + chessboardDetails?.ECO
                }}
              </p>
            </div>
            }

            <div
              class="row mx-2 px-1 justify-content-start move-scroll vertical-moves"
              #moveScrollContainer2
            >
              <div *ngFor="let item of moves; let i = index" class="col-6 move-one-section p-0 mb-0">
                <div class="d-flex align-items-center">
                  <span *ngIf="i % 2 === 0" class="font mb-1 mx-2 numbers">{{ i / 2 + 1 }}.</span>
                  <p
                    class="mb-2 move-box-border"
                    (click)="getMove(i)"
                    [innerHTML]="item | pieceIcon"
                    [ngClass]="{ 'selected-move': i + 1 === currentIndex }"
                  >
                    {{ item }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="game-btn-mode my-4">
            <button
              class="btn move-button rounded"
              (click)="resetChessBoard()"
              (keydown)="onKeyDown($event)"
            >
              <i class="fa-solid fa-backward-step font"></i>
            </button>
            <button
              class="btn move-button rounded"
              (click)="prevMove()"
              (keydown)="onKeyDown($event)"
            >
              <i class="fa-solid fa-angle-left font"></i>
            </button>
            <button
              class="btn move-button rounded"
              (click)="nextMove()"
              (keydown)="onKeyDown($event)"
            >
              <i class="fa-solid fa-angle-right font"></i>
            </button>
            <button class="btn move-button rounded" (click)="endChessBoard()">
              <i class="fa-solid fa-forward-step font"></i>
            </button>
            <button
              class="btn move-button rounded"
              (click)="filpChessBoard()"
              (keydown)="onKeyDown($event)"
            >
              <i class="fa-solid fa-repeat font"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-login-popup
  [displayStyle]="modalDisplayStyle"
  (myout)="GetChildData($event)"
></app-login-popup>
